export type ProcurementRow = {
  Rgt: number;
  Lft: number;
  total_used_in_assemblies: number;
  stock_warehouse: number;
  stock_trianval: number;
  total_quantity: number;
};

const toNumber = (value: number | string | null | undefined) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const isLeafRow = (row: ProcurementRow) => row.Rgt - row.Lft === 1;

export const getUsedInParentAssemblies = (row: ProcurementRow) => {
  const usedInParentAssemblies = toNumber(row.total_used_in_assemblies);
  return usedInParentAssemblies > 0 ? usedInParentAssemblies : 0;
};

export const getTotalStock = (row: ProcurementRow) => {
  const trianvalStock = toNumber(row.stock_trianval);
  return toNumber(row.stock_warehouse) + (trianvalStock < 0 ? 0 : trianvalStock) + getUsedInParentAssemblies(row);
};

export const getTotalQtyNeeded = (row: ProcurementRow, forecastedQty: number) => toNumber(row.total_quantity) * toNumber(forecastedQty);

export const getShortageBeforePurchaseOrders = (row: ProcurementRow, forecastedQty: number) => getTotalQtyNeeded(row, forecastedQty) - getTotalStock(row);

export const getToBuyRawMaterial = getShortageBeforePurchaseOrders;

export const getIncomingPurchaseQty = (part: { IncomingPurchaseQty?: number | string | null } | null | undefined) => Math.max(toNumber(part?.IncomingPurchaseQty), 0);

export const getToOrderQty = (shortageQty: number, incomingPurchaseQty: number) => Math.max(toNumber(shortageQty) - toNumber(incomingPurchaseQty), 0);
